import { Modal } from "antd";
import { PurchaseItemForm } from "./PurchaseItemForm";

const PurchaseItemModal = ({
  isOpenModal,
  title,
  setIsOpenModal,
  productionRefetch,
}) => {
  return (
    <div className="container-fluid mx-auto ">
      <Modal
        open={isOpenModal}
        closable={false}
        onCancel={() => setIsOpenModal(false)}
        footer={null}
        width={580}
        centered
        title={title}
        destroyOnClose
      >
        <PurchaseItemForm
          onCancel={() => setIsOpenModal(false)}
          productionRefetch={productionRefetch}
        />
      </Modal>
    </div>
  );
};

export default PurchaseItemModal;
